import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import { useDate } from 'hooks/useDate/useDate'

import classes from './DateLabel.module.scss'

/** @type {import('./types').default} */
const DateLabel = ({ date }) => {
  const { getDate } = useDate()
  const displayDate = date ? getDate(date).format('MMM D, YYYY') : ''

  return (
    <div className={clsx('DateLabel', classes.date)}>
      <Icon icon={['far', 'calendar']} className={classes.dateIcon} /> {displayDate}
    </div>
  )
}

export default DateLabel
